import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminGeckoCheckMCP from "@/pages/AdminGeckoCheckMCP";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/geckocheck-mcp")({
  head: () => seoHead("/admin/geckocheck-mcp"),
  component: () => (
    <AdminGate><AdminGeckoCheckMCP /></AdminGate>
  ),
});
